import { createSlice } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';
import { setErrorMessage } from './errors';
import { mapErrorMessage } from '../utils';
import api from '../api';

const initialState = {
  productTypes: [],
  selected: null,
  loading: false,
  error: null,
};

const insuranceTypesSlice = createSlice({
  name: 'insuranceTypes',
  initialState,
  reducers: {
    fetchInsurancesStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchInsurancesSuccess(state, action) {
      state.loading = false;
      state.productTypes = action.payload;
      // state.productTypes = { ...state.productTypes, ...action.payload };
      state.error = null;
    },
    fetchInsurancesFailure(state, action) {
      state.loading = false;
      state.error = action.payload || true;
    },
    setSelectedInsurance(state, action) {
      state.selected = { ...state.selected, ...action.payload };
    },
  },
});

const { actions, reducer } = insuranceTypesSlice;

export const {
  fetchInsurancesStart,
  fetchInsurancesSuccess,
  fetchInsurancesFailure,
  setSelectedInsurance,
} = actions;

export const fetchInsurances = () => async (dispatch, getState) => {
  try {
    dispatch(fetchInsurancesStart());
    const { auth, user } = getState();

    const { data } = await api.post(
      '/seguros/productos/ofertas/ch/PDS',
      {
        channelId: '341',
        insuranceCompanyId: '36',
        isEmployee: user.empleado,
      },
      {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }
    );
    dispatch(fetchInsurancesSuccess(data.insuranceProductTypes || []));
  } catch (error) {
    dispatch(fetchInsurancesFailure());
    dispatch(setErrorMessage(mapErrorMessage('systemError')));
    dispatch(push('/error'));
    return;
  }
};

export default reducer;
